<template>
  <div>
    <product-list
      :grid-size-selector="$feature.showGridSizeSelectorOnSRP"
      :header-title="searchQuery ? replaceAll($t.searchResultsFor, { query: searchQuery }) : undefined"
      :hide-rating="!$feature.showRatingOnPLP"
      :list="productData"
      :next-page-loading="pending && infinityLoad"
      :pickup-filters="$feature.showPickupFiltersOnSRP"
      :products-loading="pending && !infinityLoad"
      :redirected
      :side-filters
      :tracking-category
      @load-more="$emit('loadMore')"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Search } from '#root/api/clients/product/data-contracts'

defineOptions({ name: 'ProductSearchPage' })

const {
  productData = null,
  trackingCategory = ''
} = defineProps<{
  productData?: Search | null
  pending: boolean
  sideFilters: boolean
  infinityLoad: boolean
  trackingCategory?: string
  searchQuery: string
  redirected?: boolean
}>()

defineEmits<{
  loadMore: []
}>()
</script>
